import { Component, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-flow-chart-dialog',
    templateUrl: './flow-chart-dialog.component.html',
    styleUrls: ['./flow-chart-dialog.component.css'],
    imports: [MatIconButton, MatDialogClose, MatIcon]
})
export class FlowChartDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
